// If you add a new font, you should communicate with the Spidy-sa server team.
// They will need to add this font to their models
export enum availableFonts {
  BebasNeue = "Bebas+Neue",
  DMSans = "DM+Sans",
  Inter = "Inter",
  Kanit = "Kanit",
  Lato = "Lato",
  Merriweather = "Merriweather",
  Montserrat = "Montserrat",
  OpenSans = "Open+Sans",
  PlayfairDisplay = "Playfair+Display",
  Poppins = "Poppins",
  Roboto = "Roboto",
  TitilliumWeb = "Titillium+Web",
  WorkSans = "Work+Sans",
}

export const DEFAULT_FONTS_SUFFIX = ", -apple-system, sans-serif";

export const addDefaultFonts = (font: availableFonts) => `${font}${DEFAULT_FONTS_SUFFIX}`;

export const FONT_ID_TO_FONT_FAMILY_MAP: Record<availableFonts, string> = {
  [availableFonts.Kanit]: addDefaultFonts(availableFonts.Kanit),
  [availableFonts.Poppins]: addDefaultFonts(availableFonts.Poppins),
  [availableFonts.Roboto]: addDefaultFonts(availableFonts.Roboto),
  [availableFonts.TitilliumWeb]: addDefaultFonts(availableFonts.TitilliumWeb),
  [availableFonts.Inter]: addDefaultFonts(availableFonts.Inter),
  [availableFonts.WorkSans]: addDefaultFonts(availableFonts.WorkSans),
  [availableFonts.DMSans]: addDefaultFonts(availableFonts.DMSans),
  [availableFonts.Montserrat]: addDefaultFonts(availableFonts.Montserrat),
  [availableFonts.OpenSans]: addDefaultFonts(availableFonts.OpenSans),
  [availableFonts.Lato]: addDefaultFonts(availableFonts.Lato),
  [availableFonts.Merriweather]: addDefaultFonts(availableFonts.Merriweather),
  [availableFonts.BebasNeue]: addDefaultFonts(availableFonts.BebasNeue),
  [availableFonts.PlayfairDisplay]: addDefaultFonts(availableFonts.PlayfairDisplay),
};

export const FONT_ID_TO_FONT_CDN_PATH_MAP: Record<availableFonts, string> = {
  [availableFonts.Kanit]: "/fonts/dialonce/kanit-v17-latin/kanit.css",
  [availableFonts.Poppins]: "/fonts/dialonce/poppins-v24-latin/poppins.css",
  [availableFonts.Roboto]: "/fonts/dialonce/roboto-v51-latin/roboto.css",
  [availableFonts.TitilliumWeb]: "/fonts/dialonce/titillium-web-v19-latin/titillium-web.css",
  [availableFonts.Inter]: "/fonts/dialonce/inter-v20-latin/inter.css",
  [availableFonts.WorkSans]: "/fonts/dialonce/work-sans-v24-latin/work-sans.css",
  [availableFonts.DMSans]: "/fonts/dialonce/dm-sans-v17-latin/dm-sans.css",
  [availableFonts.Montserrat]: "/fonts/dialonce/montserrat-v31-latin/montserrat.css",
  [availableFonts.OpenSans]: "/fonts/dialonce/open-sans-v44-latin/open-sans.css",
  [availableFonts.Lato]: "/fonts/dialonce/lato-v25-latin/lato.css",
  [availableFonts.Merriweather]: "/fonts/dialonce/merriweather-v33-latin/merriweather.css",
  [availableFonts.BebasNeue]: "/fonts/dialonce/bebas-neue-v16-latin/bebas-neue.css",
  [availableFonts.PlayfairDisplay]:
    "/fonts/dialonce/playfair-display-v40-latin/playfair-display.css",
};
